import React from 'react';
// import MCQuestionContent from '../QuestionContent/MCQuestion';
// import ShortQuestionContent from '../QuestionContent/ShortQuestion';
// import LongQuestionContent from '../QuestionContent/LongQuestion';
import QuestionContent from '../QuestionContent/QuestionContent';
import RaisedButton from 'material-ui/RaisedButton';

var EditorStep3 = React.createClass({
  prevStep: function() {
    this.handleStepChange(1);
  },
  handleStepChange: function(value) {
    this.props.onStepChange(value);
  },
  submitCollection: function() {
    this.props.submitCollection();
  },
  getInitialState: function() {
    return {
      questions: this.props.questions
    }
  },
  componentWillMount: function() {

  },
  componentWillReceiveProps: function(nextProps) {
    var questions = nextProps.questions;
    this.setState({
      questions: questions
    })
  },
  render: function() {
    var _this = this;
    return (
      <div>
        <div className="text-right" style={{"marginTop": "10px"}}>
          <RaisedButton
            onClick={_this.prevStep}
            label="Edit Questions"
            secondary={true}
            icon={<i style={{"color": "white"}} className="fa fa-angle-left" />}
          />
          <RaisedButton
            onClick={_this.submitCollection}
            label="Submit"
            primary={true}
            icon={<i style={{"color": "white"}} className="fa fa-check" />}
          />
        </div>
        <div className="content-play" style={{"maxWidth": "750px", "margin": "auto", "padding": "25px 0"}}>
          <QuestionContent questions={_this.state.questions} conceptLeafMapping={_this.props.conceptLeaf} />
        </div>
      </div>
    )
  },
  componentDidMount: function() {

  }
});

export default EditorStep3;



/** WEBPACK FOOTER **
 ** ./src/components/CollectionEditor/EditorStep3.js
 **/